//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { useContext } from 'react';
import { SnackbarContext } from '@/contexts/SnackbarContext';

// Returns showSnackbar(message, severity?) for surfacing transient alerts.
export function useSnackbar() {
  const ctx = useContext(SnackbarContext);
  if (!ctx)
    throw new Error('useSnackbar must be used within a SnackbarProvider');

  return ctx.showSnackbar;
}

// Returns setStatus(message | null) for a persistent (non-auto-hiding) status
// banner used by long-running work like a load.
export function useStatusBanner() {
  const ctx = useContext(SnackbarContext);
  if (!ctx)
    throw new Error('useStatusBanner must be used within a SnackbarProvider');

  return ctx.setStatus;
}
